exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.indent-contact-body[data-v-2e5c4e80] {\n  white-space: pre-line;\n  word-break: break-all;\n}\n.control-label[data-v-2e5c4e80] {\n  font-size:120%;\n}\n", ""]);

// exports
